import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AdminNotifiProvider } from "./AdminNotifiContext";
import { AdminModiratorProvider } from "./AdminModiratorContext";
import { AdminUsersProvider } from "./AdminUsersContext";
import { AdminBooksProvider } from "./AdminBooksContext";
import { AdminAllUsersProvider } from "./AdminAllUsersContext";
import { AdminServiceProvider } from "./AdminServiceContext";
import { AdminAdvServiceProvider } from "./AdminAdvServiceContext";
import { AdminPaymentProvider } from "./AdminPaymentContext";
import { AdminProfileProvider } from "./AdminProfileContext";
import { AdminOffersProvider } from "./AdminOffersContext";
import { useLangUrl } from "../../utilities/useLangUrl";
import { AdminLibCategoryProvider } from "../Admins/AdminLibCategoryContext";

// import Cookies from 'js-cookie';

const AdminContext = createContext();

export function AdminProvider({ children }) {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const langUrl = useLangUrl();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }
        async function fetchProfile() {
            try {
                const data = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/users/my-profile`);
                setProfile(data);
                if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.register('/firebase-messaging-sw.js')
                        .then((registration) => {
                            console.log('Service Worker registered with scope:', registration.scope);
                        }).catch((error) => {
                            console.error('Service Worker registration failed:', error);
                        });
                }
            } catch (err) {
                setProfile(null);
            } finally {
                setLoading(false);
            }
        }
        fetchProfile();
    }, [navigate, langUrl]);


    return (
        <AdminContext.Provider value={{ profile, loading, setProfile, setLoading }}>
            <AdminNotifiProvider>
                <AdminLibCategoryProvider>
                    <AdminAllUsersProvider>
                        <AdminUsersProvider>
                            <AdminModiratorProvider>
                                <AdminPaymentProvider>
                                    <AdminProfileProvider>
                                        <AdminServiceProvider>
                                            <AdminAdvServiceProvider>
                                                <AdminOffersProvider>
                                                    <AdminBooksProvider>
                                                        {children}
                                                    </AdminBooksProvider>
                                                </AdminOffersProvider>
                                            </AdminAdvServiceProvider>
                                        </AdminServiceProvider>
                                    </AdminProfileProvider>
                                </AdminPaymentProvider>
                            </AdminModiratorProvider>
                        </AdminUsersProvider>
                    </AdminAllUsersProvider>
                </AdminLibCategoryProvider>
            </AdminNotifiProvider>
        </AdminContext.Provider>
    );
}

export function useAdmin() {
    return useContext(AdminContext);
}